import React, { useEffect } from "react";
import "./App.scss";
import { BrowserRouter, Switch } from "react-router-dom";
import Routes from "./Routes";
import { Provider } from "react-redux";
import store from "store";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DayjsUtils from "@date-io/dayjs";
import TokenHandler from "TokenHandler";
import { createLogOverrides, logError } from "apis/LogService";
import { ErrorBoundary } from "react-error-boundary";
import { getUsername } from "utils/Common";
import ErrorFallback from "components/ErrorFallback/ErrorFallback";
import Alerts from "components/Alerts/Alerts";
import { enforceSecureCookieFlags } from "utils/cookieSecurity";

function App() {
  useEffect(() => {
    createLogOverrides();
    enforceSecureCookieFlags();
  }, []);
  const onError = (error) => {
    logError(error, getUsername());
  };
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={onError}>
      <Provider store={store}>
        <MuiPickersUtilsProvider utils={DayjsUtils}>
          <div className="_app">
            <Alerts />
            <BrowserRouter>
              <TokenHandler>
                <Switch>
                  <Routes />
                </Switch>
              </TokenHandler>
            </BrowserRouter>
          </div>
        </MuiPickersUtilsProvider>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
